import { oklab, rgb, formatHex } from 'https://cdn.skypack.dev/culori';

// Constants
const dateObj = new Date();
const currentYear = dateObj.getFullYear();
const currentMonth = dateObj.getMonth();
const currentDate = dateObj.getDate();
const date = currentYear + (currentMonth * 10000) + (currentDate * 1000000);
const rand = mulberry32(date);
const randomNumbers = [getRand(0,1.0), getRand(0,1.0), getRand(0,1.0)];

// Startup
resizeContent();

// Listeners
//   Window
window.addWindowListeners = function() {
    // Load
    window.addEventListener("load", function(){
        setYear();
        let pageColorOpt = this.document.getElementById("page-color");
        if (pageColorOpt != null) {
            initializeBackgroundColor(pageColorOpt.innerText);
        } else {
            initializeDailyBackgroundColor();
        }
        let app = document.getElementById("app");
        app.style.visibility = "visible";
    });

    // Resize
    window.addEventListener("resize", function(){
        resizeContent();
    });
}
addWindowListeners();

// Functions
//   Window Functions
window.renderSection = function(section_id) {
    fetch("/?section_id=" + section_id, {
        method: "GET"
    })
    .then(response => response.text())
    .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newContent = doc.getElementById(section_id).innerHTML;
        document.getElementById(section_id).innerHTML = newContent;

        const updateEvent = new CustomEvent("section:updated", {
            detail: {sectionId: section_id}
        });
        document.dispatchEvent(updateEvent);
    });
}

window.renderSectionURL = function(page_url, section_id) {
    fetch(page_url + "?section_id=" + section_id, {
        method: "GET"
    })
    .then(response => response.text())
    .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newContent = doc.getElementById("shopify-section-" + section_id).innerHTML;
        document.getElementById("shopify-section-" + section_id).innerHTML = newContent;
        window.history.pushState({}, "", page_url);

        const updateEvent = new CustomEvent("section:updated", {
            detail: {sectionId: section_id}
        });
        document.dispatchEvent(updateEvent);
    });
}

//   Export Functions
export function initializeDailyBackgroundColor() {
    let bgColorRgb = rgb("000000");
    bgColorRgb.r = randomNumbers[0];
    bgColorRgb.g = randomNumbers[1];
    bgColorRgb.b = randomNumbers[2];

    let bgColor = oklab(bgColorRgb);

    bgColor.l = 0.8;

    let hexColor = formatHex(bgColor);
    document.body.style.backgroundColor = hexColor;
    setFaviconColor(hexColor);
}

export function initializeBackgroundColor(colorOption) {
    if (colorOption) {
        document.body.style.backgroundColor = colorOption;
        setFaviconColor(colorOption);
    } else {
        initializeDailyBackgroundColor();
    }
}

export function resizeContent() {
    let navBar = document.getElementById("nav-bar");
    let footer = document.getElementById("footer");
    let preFooter = document.getElementById("pre-footer");
    let styleNB = window.getComputedStyle(navBar, null);
    let footerH = "0px";
    if (footer != null) {
        let styleF = window.getComputedStyle(footer, null);
        footerH = styleF.getPropertyValue("height");
    }
    let preFooterH = "0px";
    if (preFooter != null) {
        let stylePF = window.getComputedStyle(preFooter, null);
        preFooterH = stylePF.getPropertyValue("height");
    }

    let content = document.getElementById("content");

    content.style.top = styleNB.getPropertyValue("height");
    content.style.bottom = parseInt(footerH, 10) + parseInt(preFooterH, 10) + "px";
}

//   Helper Functions
function mulberry32(a) {
    return function() {
      var t = a += 0x6D2B79F5;
      t = Math.imul(t ^ t >>> 15, t | 1);
      t ^= t + Math.imul(t ^ t >>> 7, t | 61);
      return ((t ^ t >>> 14) >>> 0) / 4294967296;
    }
}

function getRand(min, max) {
    return (rand() * (max - min)) + min
}

function setYear() {
    let yearItems = document.getElementsByClassName("year");
    for (const yearItem of yearItems) {
        yearItem.innerHTML = currentYear;
    }
}

async function setFaviconColor(color) {
    const canvas = document.createElement('canvas');

    canvas.width = 8; 
    canvas.height = 8;

    const context = canvas.getContext('2d');

    context.fillStyle = color;
    context.fillRect(0, 0, canvas.width, canvas.height);

    let link = document.querySelector('link[rel~="icon"]');
    if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.head.appendChild(link);
    }

    link.href = canvas.toDataURL('image/png');
}